import React from 'react';
import { format } from 'date-fns';

import TimePicker from './TimePicker';
import DatePicker from './DatePicker';

import { IconChevron, IconClock, IconWheelchair, IconPedestrian, IconPhone } from '../Icons';

import {convertPickupType} from '../../utils/index';

class PlannerOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        };
    }

    updateWalkPreferenceFields(event) {
        let mockWalkReluctanceField = {
            target: {
                name: 'walkReluctance',
                value: '3.0'
            }
        };
        let mockMaxWalkField = {
            target: {
                name: 'maxWalkDistance',
                value: '1600'
            }
        };
        switch(event.target.value) {
        case 'default':
            break;
        case 'less':
            mockWalkReluctanceField.target.value = '10.0';
            break;
        case 'no':
            mockWalkReluctanceField.target.value = '10.0';
            mockMaxWalkField.target.value = '50';
            break;
        case 'prefer':
            mockWalkReluctanceField.target.value = '1.0';
            mockMaxWalkField.target.value = '4000';
        }
        this.props.handleInput(mockMaxWalkField);
        this.props.handleInput(mockWalkReluctanceField);
    }

    renderSummary() {
        const leaving = this.props.form.arriveBy.value === 'true'
            ? 'Arriving by'
            : 'Departing after';
        const optionsDate = format(this.props.form.date.value, 'MMMM Do');
        const eligibilityText = getEligibilityDescription(this.props.form);
        const walkingText = getWalkPreferenceText(this.props.form.walkPreference.value);
        return(
            <div className="otp-options-summary">
                <div className="otp-options-fields">
                    <div className="otp-form-row otp-datetime-summary">
                        <IconClock />
                        {leaving} {this.props.form.time.value} on {optionsDate}
                    </div>
                    <div className="otp-form-row otp-details-summary">
                        <div className="otp-eligibility-summary">
                            <IconWheelchair />
                            {eligibilityText}
                        </div>
                        <div className="otp-walking-summary">
                            <IconPedestrian />
                            {walkingText}
                        </div>
                    </div>
                </div>
                {!this.props.showSummary &&
                <div className="otp-edit-options">
                    <button
                        aria-label="Edit trip options"
                        onClick={() => this.setState({collapsed: false})}
                    >
                        <IconChevron />
                    </button>
                </div>
                }
            </div>
        );
    }

    render() {
        if (this.state.collapsed || this.props.showSummary) {
            return this.renderSummary();
        }
        return (
            <div className="otp-planner-options">
                <div className="otp-form-control">
                    <input
                        type="radio"
                        id="dep-after"
                        name="arriveBy"
                        value="false"
                        checked={this.props.form.arriveBy.value === 'false'}
                        onChange={this.props.handleInput}
                    />
                    <label htmlFor="dep-after">Depart After</label>
                    <input
                        type="radio"
                        id="arrive-by"
                        name="arriveBy"
                        value="true"
                        checked={this.props.form.arriveBy.value === 'true'}
                        onChange={this.props.handleInput}
                    />
                    <label htmlFor="arrive-by">Arrive By</label>
                </div>
                <div className="otp-form-row">
                    <div className="otp-form-control otp-has-dropdown otp-has-btn">
                        <label htmlFor="time" className="screen-reader-text">Time</label>
                        <input
                            name="time"
                            id="time"
                            type="text"
                            value={this.props.form.time.value}
                            onChange={this.props.handleInput}
                        />
                        <TimePicker
                            handleInput={this.props.handleInput}
                            value={this.props.form.time.value}
                        />
                    </div>
                    <div className="otp-form-control otp-has-dropdown">
                        <label htmlFor="date" className="screen-reader-text">Date</label>
                        <DatePicker
                            handleInput={this.props.handleInput}
                            value={this.props.form.date.value}
                        />
                    </div>
                </div>
                <div className="otp-form-row">
                    <div className="otp-form-control">
                        <label htmlFor="walkPreference">Walking Preference</label>
                        <select
                            name="walkPreference"
                            id="walkPreference"
                            onChange={event => {
                                this.updateWalkPreferenceFields(event);
                                this.props.handleInput(event);
                            }}
                            value={this.props.form.walkPreference.value}
                        >
                            <option value="default">Shortest Trip</option>
                            <option value="less">Less Walking</option>
                            <option value="no">No Walking</option>
                            <option value="prefer">Prefer Walking</option>
                        </select>
                    </div>
                    {window.otpConfig.flex2 && 
                        <div className="otp-form-control">
                            <input
                                type="checkbox"
                                checked={this.props.form.flexUseReservationServices.value === 'true'}
                                name="flexUseReservationServices"
                                id="flexUseReservationServices"
                                onChange={event => {
                                    this.props.handleInput(event);
                                    let dupeEvent = {target: {name: 'requiresReservation', value: convertPickupType(event.target.checked)}};
                                    this.props.handleInput(dupeEvent);
                                }}
                            />
                            <label htmlFor="flexUseReservationServices">Include trips requiring reservations</label>
                        </div>
                    }
                    {!window.otpConfig.flex2 && 
                        <>
                            <div className="otp-form-control">
                            <input
                                    type="checkbox"
                                    checked={this.props.form.flexUseReservationServices.value === 'true'}
                                    name="flexUseReservationServices"
                                    id="flexUseReservationServices"
                                    onChange={this.props.handleInput}
                                />
                                <label htmlFor="flexUseReservationServices">Include trips requiring reservations</label>
                            </div>
                            <div className="otp-form-control">
                                <input
                                    type="checkbox"
                                    checked={this.props.form.flexUseEligibilityServices.value === 'true'}
                                    name="flexUseEligibilityServices"
                                    id="flexUseEligibilityServices"
                                    onChange={this.props.handleInput}
                                />
                                <label htmlFor="flexUseEligibilityServices">Include trips with eligibility requirements</label>
                            </div>
                        </>
                    }
                </div>
            </div>
        );
    }
}

const getEligibilityDescription = form => {
    if (window.otpConfig.flex2) {
        if (form.flexUseReservationServices.value === 'true') {
            return 'Showing ALL trips';
        }
    } else {
        if ((form.flexUseReservationServices.value === 'true') && (form.flexUseEligibilityServices.value === 'true')) {
            return 'Showing ALL trips';
        }
        if (form.flexUseEligibilityServices.value === 'true') {
            return 'Excluding trips with advance reservations';
        }
        if (form.flexUseReservationServices.value === 'true') {
            return 'Excluding trips with eligibility requirements';
        }
    }
    return 'Excluding trips with eligibility requirements or reservations';
};

const getWalkPreferenceText = formValue => {
    switch(formValue) {
    case 'default':
        return 'Shortest trip';
    case 'less':
        return 'Minimize walking';
    case 'no':
        return 'No walking';
    case 'prefer':
        return 'Prefer walking';
    }
};

export default PlannerOptions;
